import { CanMatchFn, Router } from '@angular/router';
import { UserStore } from '../../../store/user/user.store';
import { inject } from '@angular/core';
import { providerRouter } from './helper/provider-router.helper';

export const onboardingPendingMatchGuard: CanMatchFn = (route, segments) => {
  const userStore = inject(UserStore)
  const router = inject(Router)
  return userStore.onboarding_status() >= 6 && !userStore.active() ? true : router.createUrlTree([providerRouter(userStore.onboarding_status())])
};
